module.exports = __webpack_public_path__ + "img/gmp-NB.30808b07.jpg";